import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'summarise',
  name: 'Summarise',
  category: 'utilities',
  description: 'Aggregate and group array data like an Excel pivot table',
  icon: 'TableProperties',
  color: 'violet',
  version: '1.0.0',

  group: ['transform'],

  defaults: {
    name: 'Summarise',
    color: '#8b5cf6'
  },

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],

  tags: ['summarise', 'summarize', 'pivot', 'group', 'aggregate', 'groupby', 'transform'],

  metadata: {
    documentation: 'https://docs.evoworkflow.com/nodes/utilities/summarise'
  }
};

export default definition;
